"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _DigitalProductDetail = _interopRequireDefault(require("./DigitalProductDetail01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DigitalProductAccessCode = (0, _component.default)(function () {
  return import("../../components/DigitalProductAccessCode");
});
var DigitalProductDetails = (0, _component.default)(function () {
  return import("../../components/DigitalProductDetails");
});
var DigitalProductDetail01 = function DigitalProductDetail01(_ref) {
  var _ref$defaultLang = _ref.defaultLang,
    defaultLang = _ref$defaultLang === void 0 ? "de" : _ref$defaultLang;
  var _useContext = (0, _react.useContext)(_PageContext.default),
    _useContext2 = _slicedToArray(_useContext, 1),
    pageData = _useContext2[0];
  var _ref2 = pageData || {},
    pageDataLang = _ref2.lang;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    accessCode = _useState2[0],
    setAcccessCode = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultLang),
    _useState4 = _slicedToArray(_useState3, 2),
    lang = _useState4[0],
    setLang = _useState4[1];
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    search = _useLocation.search;
  var css = (0, _DigitalProductDetail.default)();
  var params = new URLSearchParams(search);
  var token = params.get("token");
  (0, _react.useEffect)(function () {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  var handleSubmit = function handleSubmit(data) {
    var accessCode = data.accessCode,
      _data$data = data.data,
      _data$data2 = _data$data === void 0 ? {} : _data$data,
      valid = _data$data2.valid;
    if (valid) {
      setAcccessCode(accessCode);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, accessCode ? /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.digitalProductDetail, "mco-shop-digital-product-detail"),
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement(DigitalProductDetails, {
    accessCode: accessCode,
    lang: lang,
    token: token
  })) : /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.digitalProductDetail, "mco-shop-digital-product-detail"),
    maxWidth: "sm"
  }, /*#__PURE__*/_react.default.createElement(DigitalProductAccessCode, {
    lang: lang,
    token: token,
    onSubmit: handleSubmit
  })));
};
var _default = DigitalProductDetail01;
exports.default = _default;